import { Injectable } from "@angular/core";
@Injectable()
export class Address {    
    FirstName: string;
    LastName: string;
    StreetAddress: string;
    ApartmentSuite: string;
    AdditionalAddressInformation : string;
    ProvinceRegion: string;
    City: string;
    State: string;
    Country: string;
    Zip: string;
    TelNum: string;
    FaxNum: string;
    Email: string;
    //ContactId:string;
    //CustomerId:string;
}